import { render, staticRenderFns } from "./GlobalTitles.vue?vue&type=template&id=021dfb2e&scoped=true"
import script from "./GlobalTitles.vue?vue&type=script&setup=true&lang=ts"
export * from "./GlobalTitles.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./GlobalTitles.vue?vue&type=style&index=0&id=021dfb2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021dfb2e",
  null
  
)

export default component.exports